import styled from 'styled-components';

import { Color } from '@pushwoosh/kit-constants';

export const FormStyled = styled.form`
  > * + * {
    &:not(:empty) {
      margin-top: 24px;
    }
  }
`;

export const InputFieldsBox = styled.div`
  display: flex;
  flex-direction: column;
  color: ${Color.MAIN};

  > * + * {
    margin-top: 16px;
  }
`;
